module.exports = __webpack_public_path__ + "img/Feedback.5e148cde.png";